import { httpClient } from "../http/httpClient";

export type LeadHistoryItem = {
  action: string;
  type?: string;
  value?: number;
  updatedAt: string;
};

export type LeadHistory = {
  date: string;
  items: LeadHistoryItem[];
};

export type LeadDetails = {
  _id: string;
  name: string;
  phone: string;
  cpf: string;
  birthDate: string;
  linkName: string;
  contacted: boolean;
  availableBalance: number;
  isDeleted: boolean;
  history: LeadHistory[];
  createdAt: string;
  updatedAt: string;
};

export async function getLeadId(id: string) {
  const { data } = await httpClient
    .get<LeadDetails>(`/lead/${id}`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
